/**
 * META PIXEL — one pixel per product (and per language copy). Never reuse the pixel of another product.
 *
 * PIXEL_DRY_RUN = true  → nothing is sent to Meta: events are only logged to the console and to window.__pixelLog.
 * PIXEL_DRY_RUN = false → real pixel. Set it to false ONLY when the landing goes live on its own subdomain.
 *
 * Events: PageView on load · ViewContent when the offer card is seen · InitiateCheckout ONLY on the offer button.
 *
 * ITALIENISCH VISUELL™ (DACH): its own pixel, "pixel italienisch visuell 05-11" (stock 5), created 04/11.
 */
export const META_PIXEL_ID = '30022562647331707';
export const PIXEL_DRY_RUN = false;
